// extracted by mini-css-extract-plugin
module.exports = {"InputHint":"styles_InputHint__3otwF"};